import { FormGroup } from "@angular/forms";

export class FormHelper {
    static markAllControlUntouched(parentForm: FormGroup) {
        Object.keys(parentForm.controls).forEach((key) => {
          const control = parentForm.controls[key];
          control.markAsPristine();
          control.markAsUntouched();
        });
      }
      static markAllControlTouched(parentForm: FormGroup) {
        Object.keys(parentForm.controls).forEach((key) => {
          const control = parentForm.controls[key];
          control.markAllAsTouched();
        });
      }
}
